import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, orange } from '../colors';
import { GetThemeOptions } from '../../theme';
import { unityDarkTokens, unityLightTokens } from '@/theme/unityTokens';

export const warningColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityLightTokens['--data-informative-intermediate'],
          highContrast: unityLightTokens['--data-informative-intermediate-high-contrast'],
          lowContrast: unityLightTokens['--data-informative-intermediate-low-contrast'],
        }
      : {
          main: unityDarkTokens['--data-informative-intermediate'],
          highContrast: unityDarkTokens['--data-informative-intermediate-high-contrast'],
          lowContrast: unityDarkTokens['--data-informative-intermediate-low-contrast'],
        };
  }

  return mode === 'light'
    ? {
        main: orange[400],
        highContrast: orange[700],
        lowContrast: orange[100],
      }
    : {
        main: orange[400],
        highContrast: orange[100],
        lowContrast: orange[800],
      };
};
